import { type FC } from 'react';
import {
  DotsThreeCircle
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconDotsThreeCircleProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconDotsThreeCircle: FC<UiIconDotsThreeCircleProps> = (props) => {
  return (
    <UiIcon
      IconComponent={DotsThreeCircle}
      {...props}
    />
  );
};
